import React, { useEffect, useState } from "react";
import "./component.css";
import Step1 from "../assets/image/aadhar-card1.png";
import Step2 from "../assets/image/aadhar-card3.png";
import Step3 from "../assets/image/aadhar-card2.png";

const HeroSection = () => {
  const cards = [
    {
      step: "Step 1",
      title: "Enter Your Aadhaar ID",
      desc: "Provide your Aadhaar details for verification.",
      icon: Step1,
    },
    {
      step: "Step 2",
      title: "Link Mobile Number",
      desc: "Enter your mobile number and verify it.",
      icon: Step2,
    },
    {
      step: "Step 3",
      title: "Create Abha Address",
      desc: "Enter your Abha Address to create the ABHA profile.",
      icon: Step3,
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % cards.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [cards.length]);

  return (
    <div className="abha-container">
      <div className="abha-left">
        <h1>Create Ayushman Bharat Health Account</h1>
        <p>
          ABHA Number Card is a 14-digit unique identification number that
          serves as an identifier for individuals in India's digital healthcare
          ecosystem.
        </p>
        <button
          className="btn btn-primary"
          onClick={() =>
            window.scrollTo({
              top: 700,
              behavior: "smooth",
            })
          }
        >
          CREATE / LINK ABHA Address
        </button>
      </div>

      <div className="abha-right">
        <div className="slider-wrapper">
          <div
            className="slider-track"
            style={{ transform: `translateX(-${current * 50}%)` }}
          >
            {cards.concat(cards).map((card, index) => {
              const isActive = index % cards.length === current;
              const isNext =
                index % cards.length === (current + 1) % cards.length;

              return (
                <div key={index} className="slider-card">
                  <div
                    className={`card-body ${isActive ? "active" : ""} ${
                      isNext ? "next" : ""
                    }`}
                  >
                    <div className="card-img">
                      <img src={card.icon} alt={card.title} />
                    </div>
                    <span className="card-step">{card.step}</span>
                    <h5>{card.title}</h5>
                    <p>{card.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
